import type { ReactNode } from 'react';
import { Card, CardHeader, CardTitle, CardBody } from '@vnetwork/ui/primitives';

/** A titled sub-section inside a product template (config card / pricing block). */
export function TemplateSection({
  title,
  action,
  children,
}: {
  title: string;
  action?: ReactNode;
  children: ReactNode;
}) {
  return (
    <Card>
      <CardHeader
        style={{ padding: 'var(--vn-space-2) var(--vn-space-3)' }}
        actions={action}
      >
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardBody style={{ display: 'grid', gap: 'var(--vn-space-3)' }}>
        {children}
      </CardBody>
    </Card>
  );
}

/** Wrapper that stacks a template's sections with the standard 16px rhythm. */
export function TemplateStack({ children }: { children: ReactNode }) {
  return <div style={{ display: 'grid', gap: 'var(--vn-space-4)' }}>{children}</div>;
}
